module.exports = __webpack_public_path__ + "static/media/g.918d72fe.svg";